export default __webpack_public_path__ + "static/pragicts-digital-outreach-verticals-hospitality-e588eeb95b8ae189ee3875fce02033e8.jpg";